import api from '@/api'

function flatToHierarchy(flat: Array<orgmap.TDepartment>): Array<orgmap.TDepartmentTreeItem> {
  var roots: orgmap.TDepartmentTreeItem[] = []
  var all: { [key: string]: orgmap.TDepartmentTreeItem } = {}
  flat.forEach(function (item) {
    all[item.deptCode] = {
      ...item,
      hasChildren: item.hasChildren === 'TRUE' ? true : false,
      children: null,
      expanded: false,
      selected: false,
      users: null
    }
  })
  Object.keys(all).forEach(function (id) {
    var item = all[id]
    const parentCode = item.parentDeptCode
    if (!parentCode) {
      roots.push(item)
    } else if (parentCode in all) {
      var p = all[parentCode]
      if (!('children' in p) || !p.children) {
        p.children = []
      }
      p.children.push(item)
    } else {
      roots.push(item)
    }
  })
  return roots
}

export default {
  /**
   * 조직도 부서 목록을 조회합니다.
   * @param {object} data
   *              { parentDeptCode: {string}, // 상위 부서 코드
   *                comCode: {string}, // 회사 코드
   *                level: {number} // 조회할 트리 레벨 }
   */
  getOrgTree: function (data: orgmap.DepartmentOption): Promise<orgmap.TDepartmentTreeItem[]> {
    return api
      .post<{ items: orgmap.TDepartment[] }>({
        url: '/Hr/organization/api/list',
        data: data,
      })
      .then((res) => flatToHierarchy(res.items))
  },

  /**
   * 조직도 부서 목록을 조회합니다. (비활성 포함)
   * @param {object} data
   *              { parentDeptCode: {string}, // 상위 부서 코드
   *                comCode: {string}, // 회사 코드
   *                level: {number} // 조회할 트리 레벨 }
   */
  getOrgTreeWithDisable: function(data: orgmap.DepartmentOption): Promise<orgmap.TDepartmentTreeItem[]> {
    return api.post<{ items: orgmap.TDepartment[] }>({
        url: '/Hr/organization/api/list2',
        data: data,
    }).then((res) => flatToHierarchy(res.items))
  },

  /* 사용자 소속부서 외 부서는 상위부서까지만 조회 (초기조회시)
   * 
   */
  getOrgTreeToMyDept: function(data: orgmap.DepartmentOption): Promise<orgmap.TDepartmentTreeItem[]>{
    return api.post<{ items:orgmap.TDepartment[]}>({
      url:`/Hr/organization/api/initList`,
      data: data
    }).then((res)=> flatToHierarchy(res.items))
  },

  /**
   * 부서 코드로 조직도 내 부서 경로를 조회합니다.
   * @param {object} data
   *          { comCode: {string}, // 회사 코드
   *            deptCode: {string} // 부서 코드 }
   */
  getDeptPath: function (data: orgmap.DepartmentOption): Promise<any> {
    return api.post({
      url: '/Hr/organization/api/path',
      data: data,
    })
  },
  getDeptInfo: function (comCode: string, deptCode: string): Promise<orgmap.TDepartment> {
    return api.get({
      url: '/Hr/organization/api/dept',
      params: {
        comCode,
        deptCode,
      },
    })
  },
  /**
   * 사용자의 메일주소로 부서정보를 조회합니다.
   */
  getUserInfo: function (data: any): Promise<any> {
    return api.get({
      url: '/Hr/department/api/info',
      params: { email: data },
    })
  },
  /**
   * 회사코드와 부서코드로 부서원을 조회합니다.
   * @param {object} data
   *              { deptCode: {string}, // 부서 코드
   *                comCode: {string} // 회사 코드
   *               }
   */
  getEmployeeList: function (
    data: orgmap.DepartmentOption
  ): Promise<orgmap.PagedItemList<orgmap.UserItem>> {
    return api.post({
      url: '/Hr/department/api/list',
      data: data,
    })
  },
  /**
   * 검색어로 부서 또는 직원을 조회합니다.
   * @param {object} options 검색옵션
   */
  searchOrg: function (
    options: orgmap.SearchOptions,
    comCode: string
  ): Promise<orgmap.PagedItemList<orgmap.UserItem>> {
     
    let { query } = options
    if (query) {
      query = encodeURIComponent(query)
    }
    var data = {
      ...options,
      comCode: comCode
    }
    return api.post({
      url: '/Hr/department/api/search?searchVal=' + query,
      data: data,
    })
  },

  /**
   * 회사 목록을 가져옵니다.
   * @returns
   */
  getCompanies: function (isWithDisabled: boolean = false): Promise<Array<orgmap.Company>> {
    return api.get<{companies : appbase.company.Info[]}>({
      url: '/Common/Company/api/list?isWithDisabled=' + isWithDisabled,
    })
    .then((res: {companies : appbase.company.Info[]}) => res.companies)
    .catch((err) => err);
  },

  /**
   * 열람문서함 부서매핑 검색어로 부서 또는 직원을 조회합니다.
   * @param {string} keyword 검색창에 입력한 값
   */
  deptPermsn: function(
    options: orgmap.SearchOptions,
    comCode: string
  ): Promise<orgmap.PagedItemList<orgmap.UserItem>> {
    let { query, retiredFlag, includeAllFlag } = options
    if (query) {
      query = encodeURIComponent(query)
    }
    return api.post({
      // url: '/api/hr/department/search?searchVal=' + query,
      url: "/hr/department/api/deptpermsn?searchVal=" + query,
      data: { comCode: comCode, retiredFlag: retiredFlag, includeAllFlag: includeAllFlag },
    });
  },

  /**
   * 열람문서함 부서매핑 검색어로 부서 또는 직원을 조회합니다. (비활성 포함)
   * @param {string} keyword 검색창에 입력한 값
   */
  deptPermsnWithDisable: function(
    options: orgmap.SearchOptions,
    comCode: string
  ): Promise<orgmap.PagedItemList<orgmap.UserItem>> {
    let { query, retiredFlag, includeAllFlag } = options
    if (query) {
      query = encodeURIComponent(query)
    }
    return api.post({
      // url: '/api/hr/department/search?searchVal=' + query,
      url: "/hr/department/api/deptpermsn?searchVal=" + query,
      data: { comCode: comCode, retiredFlag: true, includeAllFlag: includeAllFlag },
    });
  },
}
